// Persistencia local (LocalStorage). Perfil, ajustes y partida guardada.
// Interfaz sencilla para poder cambiar a IndexedDB en el futuro sin tocar el resto.
import { STORAGE_KEYS } from '../utils/constants.js';

function read(key, fallback = null) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch (err) {
    console.warn('[SaveManager] Error leyendo', key, err);
    return fallback;
  }
}

function write(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (err) {
    console.warn('[SaveManager] Error escribiendo', key, err);
    return false;
  }
}

export const SaveManager = {
  // --- Perfil / progresión ---
  loadProfile() {
    return read(STORAGE_KEYS.PROFILE, defaultProfile());
  },
  saveProfile(profile) {
    return write(STORAGE_KEYS.PROFILE, profile);
  },

  // --- Ajustes ---
  loadSettings() {
    return read(STORAGE_KEYS.SETTINGS, null);
  },
  saveSettings(settings) {
    return write(STORAGE_KEYS.SETTINGS, settings);
  },

  // --- Partida en curso ---
  loadGame() {
    return read(STORAGE_KEYS.SAVEGAME, null);
  },
  saveGame(state) {
    return write(STORAGE_KEYS.SAVEGAME, state);
  },
  clearGame() {
    localStorage.removeItem(STORAGE_KEYS.SAVEGAME);
  },
  hasSavedGame() {
    return !!localStorage.getItem(STORAGE_KEYS.SAVEGAME);
  },

  /** Borra TODO el almacenamiento del juego (perfil, progreso, logros, ranking local,
   *  ajustes, amigos, partida, reto diario…). Deja PALABRIKS como recién instalado. */
  resetAll() {
    try {
      const toRemove = [];
      for (let i = 0; i < localStorage.length; i++) {
        const k = localStorage.key(i);
        if (k && k.startsWith('wb:')) toRemove.push(k);
      }
      toRemove.forEach((k) => localStorage.removeItem(k));
    } catch (err) {
      console.warn('[SaveManager] Error reiniciando el almacenamiento', err);
    }
  },

  // --- Amigos ---
  loadFriends() {
    return read(STORAGE_KEYS.FRIENDS, []);
  },
  saveFriends(list) {
    return write(STORAGE_KEYS.FRIENDS, list);
  },

  // --- Diario ---
  loadDaily() {
    return read(STORAGE_KEYS.DAILY, {});
  },
  saveDaily(data) {
    return write(STORAGE_KEYS.DAILY, data);
  },
};

export function defaultProfile() {
  return {
    name: 'Constructor',
    avatar: 'default',
    friendCode: null, // código de amigo estable (se genera en el primer arranque)
    level: 1,
    xp: 0,
    coins: 100,
    gems: 5,
    stats: {
      gamesPlayed: 0,
      wins: 0,
      abandoned: 0,
      wordsCreated: 0,
      evolutions: 0,
      familiesCompleted: 0,
      tripleTurns: 0,
      longestWord: '',
      bestWord: { word: '', points: 0 },
      bestScore: 0,
      dailyStreak: 0,
      lastPlayedDate: null,
    },
    discoveredWords: [],
    achievements: {}, // id -> { progress, unlocked, claimed }
    leaderboard: [], // ranking local: [{ name, avatar, score, self, ts }] (futuro: Firebase)
    unlockedCosmetics: ['default'],
    missionsProgress: {},
  };
}
